import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  localizeKey,
  sentryDSNKey,
  isNumberedEnv,
  OAUTH_PROVIDERS_COM,
  COOKIE_POLICY_URL,
  DATA_PROCESSING_AGREEMENT_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "dev",
  appRegion: "com",
  appEnv: "com-dev",
  urls: {
    apiBaseUrl: "https://core.api.dev.holobuilder.com",
    projectApiUrl: "https://v2.project.api.dev.holobuilder.com",
    viewerUrl:
      numberedEnv === "dev1"
        ? "https://dev1.viewer.dev.holobuilder.com"
        : "https://viewer.dev.holobuilder.com",
    webEditorUrl: "https://app.dev.holobuilder.com/app",
    apiBaseComUrl: "https://core.api.dev.holobuilder.com",
    apiBaseEuUrl: "https://core.api.dev.holobuilder.eu",
    sphereDashboardUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.dev.holobuilder.com"
        : "https://sphere.dev.holobuilder.com",
    dashboard20ComUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.dev.holobuilder.com"
        : "https://sphere.dev.holobuilder.com",
    dashboard20EuUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.dev.holobuilder.eu"
        : "https://sphere.dev.holobuilder.eu",
    sphereEntryPageComUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.dev.holobuilder.com"
        : "https://entry.dev.holobuilder.com",
    sphereEntryPageEuUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.dev.holobuilder.eu"
        : "https://entry.dev.holobuilder.eu",
    sphereEntryPageApi: "https://entry.dev.holobuilder.com/api",
    termsOfServiceUrl: TERMS_OF_SERVICE_URL,
    privacyPolicyUrl: PRIVACY_POLICY_URL,
    dataProcessingAgreementUrl: DATA_PROCESSING_AGREEMENT_URL,
    cookiePolicyUrl: COOKIE_POLICY_URL,
  },
  features: {
    localizeKey,
    sentryDSNKey,
  },
  oauth: {
    providers: OAUTH_PROVIDERS_COM,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support+dev@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
